/**
 * @generated SignedSource<<fb807816a4e5db7977ac8b58f7c51f18>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TeamIcon = "account_hard_hat" | "account_tie" | "apple" | "baby_carriage" | "baguette" | "basket" | "bed" | "bread_slice" | "broom" | "carrot" | "cart" | "cash" | "cash_register" | "cheese" | "coffe" | "cookie" | "cupcake" | "default" | "desk_lamp" | "dolly" | "fish" | "flower" | "food" | "fork_knife" | "forklift" | "fridge" | "hamburger" | "hammer_wrench" | "laptop" | "market" | "meat" | "milk" | "pineapple" | "soda" | "sofa" | "steak" | "tshirt" | "tv" | "watermelon";
export type UserAdminEditGroupDeviceScreenQuery$variables = {
  id: string;
  storeId?: string | null;
};
export type UserAdminEditGroupDeviceScreenQuery$data = {
  readonly store: {
    readonly sharedMobileDevice: {
      readonly id: string;
      readonly name: string;
      readonly teams: ReadonlyArray<{
        readonly color: string | null;
        readonly icon: TeamIcon | null;
        readonly id: string;
        readonly isPrivate: boolean;
        readonly name: string;
      }>;
    } | null;
  };
};
export type UserAdminEditGroupDeviceScreenQuery = {
  response: UserAdminEditGroupDeviceScreenQuery$data;
  variables: UserAdminEditGroupDeviceScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "storeId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "storeId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "id"
    }
  ],
  "concreteType": "SharedMobileDevice",
  "kind": "LinkedField",
  "name": "sharedMobileDevice",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Team",
      "kind": "LinkedField",
      "name": "teams",
      "plural": true,
      "selections": [
        (v2/*: any*/),
        (v3/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "icon",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "color",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isPrivate",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UserAdminEditGroupDeviceScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UserAdminEditGroupDeviceScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e2c308037bf65f1bb48fc56bd6374310",
    "id": null,
    "metadata": {},
    "name": "UserAdminEditGroupDeviceScreenQuery",
    "operationKind": "query",
    "text": "query UserAdminEditGroupDeviceScreenQuery(\n  $id: ID!\n  $storeId: ID\n) {\n  store(id: $storeId) {\n    sharedMobileDevice(id: $id) {\n      id\n      name\n      teams {\n        id\n        name\n        icon\n        color\n        isPrivate\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "9cb751b959e3567cf1949230eccb6309";

export default node;
